import Indicator from '@/utils/Indicator';
import 'mint-ui/lib/indicator/style.css';

export default Indicator;
